export class Modifier {
    constructor(type, disabled, parameters, is_symmetrical = false) {
        this.type = type;
        this.disabled = disabled;
        this.parameters = parameters;
        this.is_symmetrical = is_symmetrical;
    }
    isDisabled() {
        return this.disabled;
    }
    getType() {
        return this.type;
    }
    getParameters() {
        return this.parameters;
    }
    isSymmetrical() {
        return this.is_symmetrical;
    }
}
